import React from 'react';
import { GenericNodeView } from 'common/components/PreviewApprovalHierarchyReactFlow/NodeView';

import { HierarchyNode } from '..';

interface NodeViewProps {
  nodeData: HierarchyNode;
}

export const NodeView: React.FC<NodeViewProps> = ({ nodeData }) => (
  <GenericNodeView<HierarchyNode, any, any>
    data={nodeData}
    getEntityId={(data) => data.entityId!}
  />
);
